<template>
    <section class="page-content settings">
        <div id="generalSettings" class="wrap btn-position-wrap">
            <div class="wrap">
                <section class="global-section">
                    <div class="row">
                        <div class="col-3"><h2 class="section-title">Configuration</h2></div>
                    </div>
                </section>
                <section class="global-section">
                    <div class="row">
                        <div class="col-3"><h2 class="section-title">Notifications</h2></div>
                    </div>
                </section>
                <section class="global-section">
                    <div class="row">
                        <div class="col-3"><h2 class="section-title">Languages</h2></div>
                        <div class="col-9">
                            <div class="row sub-section">
                                <div class="col-8">
                                    <h3>New Language</h3>
                                    <div class="md-layout">
                                        <md-field class="half-field">
                                            <label>Code</label>
                                            <md-input v-model="form.code" name="code" id="code" minlength="3" maxlength="3"></md-input>
                                        </md-field>
                                        <md-field class="half-field">
                                            <label>Language</label>
                                            <md-input v-model="form.language" name="language" id="language"></md-input>
                                        </md-field>
                                        <md-button type="submit" class="ManualBtn ManualBtncancel" v-on:click="newLanguage()">save</md-button>
                                    </div>
                                    <div class="md-layout form-error">
                                        <p class="red-text" v-if="error">{{ error }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row sub-section">
                                <div class="col-8">
                                    <h3>Configured Languages</h3>
                                    <md-table>
                                        <md-table-row>
                                            <md-table-head>Code</md-table-head>
                                            <md-table-head>Language</md-table-head>
                                            <md-table-head>Action</md-table-head>
                                        </md-table-row>
                                        <md-table-row v-for="lang in languages" :key="lang.language">
                                            <md-table-cell>{{ lang.code }}</md-table-cell>
                                            <md-table-cell>{{ lang.language }}</md-table-cell>
                                            <md-table-cell>
                                                <md-button @click="confirmDelete(lang)" title="Delete Language(s)" class="md-icon-button">
                                                    <md-icon>delete</md-icon>
                                                </md-button>
                                            </md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                If you delete CHANNEL <b>{{ languageDelete.language }}({{ languageDelete.code }})</b>, you will delete this value from all customers using Cortex. Do you want to delete this CHANNEL? This action cannot be undone.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="remove(languageDelete.id)">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="closeDialog()">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
    </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {delLanguage} from '../../services/LanguageService.js';

export default {
  computed: {
    ...mapGetters('language', {languages: 'getLanguageList'})
  },
  data: () => ({
    form: {
      code: '',
      language: ''
    },
    error: null,
    showDeleteDialog: false,
    languageDelete: ''
  }),
  methods: {
    ...mapActions('language', ['createLanguage', 'loadLanguageList']),
    closeDialog () {
      this.showDeleteDialog = false;
      this.languageDelete = '';
    },
    newLanguage () {
      if (this.form.code.length < 3) {
        this.error = 'Code must be 3 characters long';
      } else if (this.form.language.length < 1) {
        this.error = 'Language cannot be empty';
      } else {
        this.error = null;
        this.createLanguage(this.form);
        this.form.code = '';
        this.form.language = '';
        this.loadLanguageList();
      }
    },
    confirmDelete (lang) {
      this.showDeleteDialog = true;
      this.languageDelete = lang;
    },
    async remove (id) {
      let result = await delLanguage(id);
      if (result.data === 'success') {
        this.showDeleteDialog = false;
        this.languageDelete = '';
        this.loadLanguageList();
      }
    }
  },
  mounted () {
    this.loadLanguageList();
  }
};
</script>

<style lang="scss">
.settings {
    .md-field {
        margin-right: 22px;
    }

    .md-field, .md-card-actions {
        float: left;
        width: 124px !important;
    }

    .md-input {
        height: 36px;
    }

    .red-text {
        color: red !important;
    }
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.stickyHeader .global .page-content .wrap .wrap {
    padding-top: 0;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/GeneralSettings.vue